import React from 'react';
import { Phone, FileCheck, MapPin, Send } from 'lucide-react';

const ABLAUF_STEPS = [
  {
    icon: Phone,
    step: '01',
    title: 'Kontaktaufnahme',
    description: 'Rufen Sie uns an oder schreiben Sie per WhatsApp. Wir klären Ihre Situation und beraten Sie unverbindlich.'
  },
  {
    icon: MapPin,
    step: '02',
    title: 'Termin vor Ort',
    description: 'Wir vereinbaren einen Termin direkt bei Ihnen – bundesweit. Meist innerhalb von 24–48 Stunden möglich.'
  },
  {
    icon: FileCheck,
    step: '03',
    title: 'Begutachtung',
    description: 'Unser Sachverständiger dokumentiert alle Schäden professionell und objektiv. Dauer: ca. 30–60 Minuten.'
  },
  {
    icon: Send,
    step: '04',
    title: 'Gutachten erhalten',
    description: 'Sie erhalten das fertige Gutachten zur Vorlage bei der Versicherung. In der Regel innerhalb von 2–3 Werktagen.'
  }
];

export const AblaufSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Unser Prozess
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Ablauf in 4 Schritten
          </h2>
          
          {/* AI-Kurzantwort-Box */}
          <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-xl p-5 mb-8 max-w-3xl mx-auto text-left">
            <p className="text-sm font-semibold text-brand-green-dark mb-2">In Kürze:</p>
            <p className="text-gray-700 leading-relaxed text-[15px]">
              Nach der Kontaktaufnahme erfolgt die Begutachtung direkt vor Ort. Anschließend wird das Gutachten erstellt und zur weiteren Verwendung bereitgestellt.
            </p>
          </div>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Von der ersten Kontaktaufnahme bis zum fertigen Gutachten
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {ABLAUF_STEPS.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative group">
                <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-8 h-full hover:border-brand-green/30 hover:shadow-2xl transition-all duration-500">
                  <div className="w-14 h-14 bg-brand-green/10 rounded-2xl flex items-center justify-center mb-6 border border-brand-green/15">
                    <Icon className="w-7 h-7 text-brand-green" />
                  </div>
                  <div className="text-sm font-bold text-brand-green mb-3">{step.step}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 tracking-tight">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-[15px]">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};